import Header from 'components/headers/addLoan'
import AddLoanIcon from 'assets/images/loans/add.svg'
import { Field, Form, Formik } from 'formik'
import { MAX_REPAYMENTS, RequestNewLoanOptions, Schema } from './utilities'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react'
import CardsModal from './modal'
import useSetRequestedLoan from './hooks/useSetRequestedLoan'
import { toast } from 'react-toastify'
import { toEnglishDigits } from 'utilities/helper/toEnglishNumber'
import Num2persian from 'utilities/helper/num2Persian'
import DotsWhiteLoading from 'components/loadings/dotsWhiteLoading'
import { NumericFormat } from 'react-number-format'
import GuarantorPickerModal, {
    IGuarantorOption,
} from 'components/modals/guarantorPicker'

interface ISelectCard {
    isOpen: boolean
    name: string
    bank: string
    bankNumber: number
}
export default function AddLoan() {
    const navigate = useNavigate()
    const { id } = useParams()
    const { state } = useLocation()
    const { mutate, isLoading } = useSetRequestedLoan()
    const [isOpenCard, setIsOpenCard] = useState<ISelectCard>({
        isOpen: false,
        name: '',
        bank: '',
        bankNumber: 0,
    })
    // ضامن‌های پیشنهادی — the manager can override these when granting
    const [guarantors, setGuarantors] = useState<Array<IGuarantorOption>>([])
    const [isOpenGuarantors, setIsOpenGuarantors] = useState<boolean>(false)

    return (
        <>
            <Formik
                initialValues={{
                    amount: '',
                    num_repayments: '',
                    // Matches the backend default (LoanDemand.demand_priority)
                    // and Android, which sends null and lets the server decide.
                    // Not something the member should be forced to answer.
                    demand_priority: 'LOW',
                    user_description: '',
                }}
                validationSchema={Schema}
                onSubmit={(values) => {
                    const payload: IAddLoanPayload = {
                        amount: Number(toEnglishDigits(String(values.amount))),
                        num_repayments: Number(
                            toEnglishDigits(String(values.num_repayments))
                        ),
                        demand_priority: values.demand_priority,
                        user_description: values.user_description,
                        selected_card_number: isOpenCard.bankNumber,
                        poolship_id: state?.poolShipId,
                        id: id ? id : '',
                        proposed_guarantors: guarantors.map(
                            (item) => item.poolship_id
                        ),
                    }
                    // The amount / instalment-count limits live in the Yup
                    // schema now, so onSubmit only runs once they hold.
                    if (!isOpenCard.bankNumber) {
                        toast.error('لطفا حساب را انتخاب کنید')
                    } else {
                        mutate(payload)
                    }
                }}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form>
                        <div className=" mx-3 flex flex-col h-screen ">
                            <div className=" grow-0">
                                <Header title="وام درخواستی خود را ثبت کنید" />
                            </div>
                            <div className=" rounded-lg grow">
                                <div className=" mt-24 bg-white rounded-lg relative pt-1">
                                    <img
                                        src={AddLoanIcon}
                                        alt="add-loan"
                                        className=" absolute right-[35%] -top-14"
                                    />
                                    <div className=" mt-14 w-full text-center">
                                        <NumericFormat
                                            customInput={Field}
                                            thousandSeparator
                                            allowNegative={false}
                                            name="amount"
                                            placeholder="مبلغ وام(تومان)"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            defaultValue={values.amount}
                                            secondaryTitle="| تومان "
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue('amount', value)
                                            }}
                                        />

                                        {errors.amount && touched.amount && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.amount}
                                            </p>
                                        )}
                                        {values.amount !== '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    values.amount.toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}

                                        <Field
                                            type="number"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            placeholder="تعداد اقساط"
                                            name="num_repayments"
                                            min={1}
                                            max={MAX_REPAYMENTS}
                                        />
                                        {errors.num_repayments &&
                                            touched.num_repayments && (
                                                <p className=" text-sm text-error-3 text-center">
                                                    {errors.num_repayments}
                                                </p>
                                            )}
                                        <div className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3">
                                            <p
                                                className=" text-placeholder"
                                                onClick={() =>
                                                    setIsOpenCard({
                                                        ...isOpenCard,
                                                        isOpen: true,
                                                    })
                                                }
                                            >
                                                {isOpenCard.name.length === 0 &&
                                                isOpenCard.bank.length === 0 ? (
                                                    'انتخاب حساب'
                                                ) : (
                                                    <span className=" text-black">
                                                        {isOpenCard.name +
                                                            ' ' +
                                                            isOpenCard.bank}
                                                    </span>
                                                )}
                                            </p>
                                        </div>
                                        <div className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3">
                                            <p
                                                className=" text-placeholder"
                                                onClick={() =>
                                                    setIsOpenGuarantors(true)
                                                }
                                            >
                                                {guarantors.length === 0 ? (
                                                    'ضامن (اختیاری)'
                                                ) : (
                                                    <span className=" text-black">
                                                        ضامن:{' '}
                                                        {guarantors
                                                            .map(
                                                                (item) =>
                                                                    item.name
                                                            )
                                                            .join('، ')}
                                                    </span>
                                                )}
                                            </p>
                                        </div>
                                        <Field
                                            as="select"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder"
                                            name="demand_priority"
                                        >
                                            {RequestNewLoanOptions.map(
                                                (item, index) => (
                                                    <option
                                                        value={item.value}
                                                        key={index}
                                                    >
                                                        {item.label}
                                                    </option>
                                                )
                                            )}
                                        </Field>
                                        <Field
                                            as="textarea"
                                            name="user_description"
                                            className="w-full outline-0 text-center py-4 px-4 text-sm"
                                            placeholder="متن پیام خود را بنویسید. این پیام فقط برای مدیران قابل مشاهده است"
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                className=" grow-0 bg-green-1 text-white py-3 rounded-lg"
                                type="submit"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <DotsWhiteLoading />
                                ) : (
                                    'ثبت درخواست وام'
                                )}
                            </button>
                            <button
                                type="button"
                                className=" text-center my-3 text-gray-4"
                                onClick={() => navigate(-1)}
                            >
                                بعدا
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
            <CardsModal
                show={isOpenCard.isOpen}
                onHide={() => setIsOpenCard({ ...isOpenCard, isOpen: false })}
                setOpenCard={setIsOpenCard}
            />
            <GuarantorPickerModal
                show={isOpenGuarantors}
                onHide={() => setIsOpenGuarantors(false)}
                moneypoolId={id}
                value={guarantors}
                onChange={setGuarantors}
                excludePoolshipId={state?.poolShipId}
                title="ضامن پیشنهادی خود را انتخاب کنید"
            />
        </>
    )
}
